const SELECTOR = '[data-hero-slideshow-container]';
const CHANGE_SLIDE_DATA_ATTRIBUTE = 'hero-slideshow-change';
const CHANGE_SLIDE_SELECTOR = `[data-${CHANGE_SLIDE_DATA_ATTRIBUTE}]`;
const $container = $(SELECTOR);
const $items = $container.find('[data-hero-slideshow-item]');
let current = $items.filter('.active').index();

let timeout, isHover = false;

const duration = 8000;

class SlideShow {
  constructor() {
    if ($(SELECTOR).size()) {
      this.attachEventHandlers();
      SlideShow.rotate();
    }
  }

  static rotate() {
    window.clearTimeout(timeout);

    timeout = window.setTimeout(() => {
      SlideShow.move();
    }, duration);
  }

  static move(direction = 1) {
    let next = current + parseInt(direction);

    if (next >= $items.length) {
      next = 0;
    } else if (next < 0) {
      next = $items.length - 1; // Off by one
    }

    $items.eq(current).removeClass('active');
    $items.eq(next).addClass('active');

    current = next;

    if (isHover === false) {
      SlideShow.rotate();
    }
  }

  attachEventHandlers() {
    $container
      .on('mouseenter', () => {
        isHover = true;
        window.clearTimeout(timeout);
      })
      .on('mouseleave', () => {
        isHover = false;
        SlideShow.rotate();
      });

    $container.on('click', CHANGE_SLIDE_SELECTOR, event => {
      const direction = $(event.currentTarget).data(CHANGE_SLIDE_DATA_ATTRIBUTE);
      SlideShow.move(direction);
      window.clearTimeout(timeout);
    });
  }
}

export default SlideShow;



// WEBPACK FOOTER //
// ./src/javascripts/Slideshow.js